var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInnovativeDigitalProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1588 53.6242L30 56.025L14.4 47.0188C14.2219 46.9159 14.0739 46.768 13.9711 46.5899C13.8682 46.4117 13.8141 46.2096 13.8141 46.0039V36.9646M46.186 36.9375V46.0038C46.186 46.2095 46.1318 46.4116 46.029 46.5898C45.9261 46.7679 45.7782 46.9158 45.6 47.0187L43.2903 48.3521M29.9494 55.7323V36.4179M13.8141 27.9902L30 18.6445L46.186 27.9902L29.9496 36.4184L13.8141 27.9902Z",
    stroke: "#A85ED1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.186 27.9902L50.3264 32.87C50.8089 33.4386 50.6446 34.3073 49.9878 34.6604L35.0778 42.6751L30 36.6907M13.7635 27.9902L9.623 32.87C9.14054 33.4386 9.30483 34.3073 9.96167 34.6604L24.8717 42.6751L29.9493 36.6908",
    stroke: "#A85ED1",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8161 17.1866C51.2575 17.1866 52.4259 16.0181 52.4259 14.5767C52.4259 13.1353 51.2575 11.9668 49.8161 11.9668C48.3747 11.9668 47.2062 13.1353 47.2062 14.5767C47.2062 16.0181 48.3747 17.1866 49.8161 17.1866Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7476 14.5781H40.8824C40.6808 14.5781 40.4825 14.6288 40.3058 14.7256C40.129 14.8224 39.9794 14.9621 39.8708 15.1318L35.746 21.5807",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0827 17.1866C11.5241 17.1866 12.6926 16.0181 12.6926 14.5767C12.6926 13.1353 11.5241 11.9668 10.0827 11.9668C8.64132 11.9668 7.47284 13.1353 7.47284 14.5767C7.47284 16.0181 8.64132 17.1866 10.0827 17.1866Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2101 21.6702L20.028 15.1318C19.9194 14.9621 19.7699 14.8224 19.5931 14.7256C19.4163 14.6288 19.218 14.5781 19.0165 14.5781H13.1512",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9494 9.19438C31.3908 9.19438 32.5592 8.02589 32.5592 6.58449C32.5592 5.14309 31.3908 3.97461 29.9494 3.97461C28.508 3.97461 27.3395 5.14309 27.3395 6.58449C27.3395 8.02589 28.508 9.19438 29.9494 9.19438Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9494 9.83984V18.8736",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.78176 26.2178C5.22316 26.2178 6.39164 25.0493 6.39164 23.6079C6.39164 22.1665 5.22316 20.998 3.78176 20.998C2.34036 20.998 1.17188 22.1665 1.17188 23.6079C1.17188 25.0493 2.34036 26.2178 3.78176 26.2178Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8141 27.5303L12.6676 24.3786C12.5854 24.1526 12.4356 23.9574 12.2386 23.8194C12.0416 23.6814 11.8069 23.6074 11.5664 23.6074H6.85022",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2182 26.2178C57.6596 26.2178 58.8281 25.0493 58.8281 23.6079C58.8281 22.1665 57.6596 20.998 56.2182 20.998C54.7768 20.998 53.6083 22.1665 53.6083 23.6079C53.6083 25.0493 54.7768 26.2178 56.2182 26.2178Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1859 27.5303L47.3324 24.3786C47.4146 24.1526 47.5644 23.9574 47.7614 23.8194C47.9584 23.6814 48.1931 23.6074 48.4336 23.6074H53.1497",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovativeDigitalProducts);
export default __webpack_public_path__ + "static/media/Innovative Digital Products.f61c68161ff468c5d91dfc4b64be808e.svg";
export { ForwardRef as ReactComponent };